module.exports = __webpack_public_path__ + "img/asleep-user.bbfb8e5d.svg";